module.exports = __webpack_public_path__ + "static/media/Viking Yacht Company Logo.84e52a06.png";